import * as routes from '@/router/route-names'

export default [
  {
    path: '/:accountId/dashboard/risk-management',
    name: routes.DASHBOARD_RISK_MANAGEMENT,
    component: () => import(/* webpackChunkName: "about" */ '../views/DashboardRiskManagement.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/certificate-insurance',
    name: routes.CERT_OF_INSURANCE,
    component: () => import('../views/risk-management/CertOfInsurance.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/evidence-property-insurance',
    name: routes.EVIDENCE_PROP_INSURANCE,
    component: () => import('../views/risk-management/EvidencePropInsurance.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/audit',
    name: routes.AUDIT,
    component: () => import('../views/risk-management/Audit.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/safety-portal',
    name: routes.SAFETY_PORTAL,
    component: () => import('../views/risk-management/SafetyPortal.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/claim-portal',
    name: routes.CLAIM_PORTAL,
    component: () => import('../views/risk-management/ClaimPortal.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/ncci',
    name: routes.NCCI,
    component: () => import('../views/risk-management/NCCI.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/osha',
    name: routes.OSHA,
    component: () => import('../views/risk-management/OSHA.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/hr',
    name: routes.HR,
    component: () => import('../views/risk-management/HR.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/billing',
    name: routes.BILLING,
    component: () => import('../views/risk-management/Billing.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/auto-id-cards',
    name: routes.AUTO_ID_CARDS,
    component: () => import('../views/risk-management/AutoIdCards.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/builders-risk-apps',
    name: routes.BR_APPLICATIONS,
    component: () => import('../views/risk-management/BuildersRiskApps.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/builders-risk-quotes',
    name: routes.BR_QUOTE,
    component: () => import('../views/risk-management/BuildersRiskQuotes.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/compliance',
    name: routes.RISK_COMPLIANCE,
    component: () => import('../views/risk-management/RiskCompliance.vue'),
  },
  {
    path: '/:accountId/dashboard/risk-management/regulatory',
    name: routes.RISK_REGULATORY,
    component: () => import('../views/risk-management/RiskRegulatory.vue'),
  },
]
